import { routes } from 'main/router';

export default routes;
